import { useEffect, useState } from 'react';

export function useDetectUserwayBiggerText() {
  const [isBiggerText, setIsBiggerText] = useState(false);

  useEffect(() => {
    let rootObserver: MutationObserver | null = null;
    let bodyObserver: MutationObserver | null = null;

    const checkZoom = (element: HTMLElement) => {
      const zoomValue = window.getComputedStyle(element).getPropertyValue('zoom');
      setIsBiggerText(zoomValue !== '1');
    };

    const observeRoot = (rootElement: HTMLElement) => {
      checkZoom(rootElement);

      rootObserver = new MutationObserver(() => {
        checkZoom(rootElement);
      });

      rootObserver.observe(rootElement, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true,
      });
    };

    const waitForRoot = () => {
      const root = document.getElementById('root');
      if (root) {
        observeRoot(root);
        return;
      }

      bodyObserver = new MutationObserver(() => {
        const foundRoot = document.getElementById('root');
        if (foundRoot) {
          bodyObserver?.disconnect();
          observeRoot(foundRoot);
        }
      });

      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    };

    waitForRoot();

    return () => {
      rootObserver?.disconnect();
      bodyObserver?.disconnect();
    };
  }, []);

  return { isBiggerText };
}
